import {
  IStudentSubjectAssessment,
  IStudentSubjectBasedStudentAssessmentListItem,
} from 'src/apis/students/studentsAssessment.interfaces';
import { mockUserAction } from '../users/userAction';
import { mockUserDetailsList } from '../users/userDetailListMock';

// Indian subject names
const subjects = [
  'Mathematics', 'English', 'Hindi', 'Science', 'Social Studies',
  'Physics', 'Chemistry', 'Biology', 'Computer Science', 'History',
  'Geography', 'Economics', 'Business Studies', 'Accountancy', 'Sanskrit',
  'French', 'German', 'Physical Education', 'Art', 'Music',
];

const scoreTypes = ['Unit Test', 'Mid Term', 'Final Exam', 'Assignment', 'Project', 'Quiz', 'Practical'];
const remarksList = [
  'Excellent performance', 'Good work', 'Needs improvement', 'Satisfactory',
  'Outstanding', 'Well done', 'Keep it up', 'Can do better',
  'Very good', 'Average performance', 'Above average', 'Below average',
];

function generateAssessment(index: number): IStudentSubjectBasedStudentAssessmentListItem {
  const studentIndex = index % mockUserDetailsList.length;
  const student = mockUserDetailsList[studentIndex];
  const subject = subjects[index % subjects.length];
  const scoreType = scoreTypes[index % scoreTypes.length];
  const maxScore = [50, 100, 150, 200][index % 4];
  const obtainedScore = Math.floor(maxScore * (0.6 + (index % 40) / 100));
  const percentage = Math.round((obtainedScore / maxScore) * 100);
  const remarks = remarksList[index % remarksList.length];
  
  const date = new Date(2024, (index % 12), (index % 28) + 1);
  
  return {
    id: String(index + 1),
    assessment: {
      id: String(index + 1),
      studentId: student.id,
      studentDetails: student.basicDetails,
      scores: {
        id: String(index + 1),
        subject,
        scoreType,
        maxScore,
        obtainedScore,
        percentage,
        date: date.toISOString().split('T')[0],
        remarks,
      },
      action: { created: mockUserAction },
    },
  };
}

const assessmentsMock: IStudentSubjectBasedStudentAssessmentListItem[] = Array.from({ length: 60 }, (_, i) => generateAssessment(i));

export const studentAssessmentSubjectBasedStudentListMock: IStudentSubjectAssessment = {
  id: '1',
  summary: {
    totalScore: assessmentsMock.reduce((sum, a) => sum + a.assessment.scores.obtainedScore, 0),
    totalPercentage: Math.round(
      assessmentsMock.reduce((sum, a) => sum + a.assessment.scores.percentage, 0) / assessmentsMock.length
    ),
    expectedStudents: 60,
    actualStudents: 60,
    passedStudents: assessmentsMock.filter(a => a.assessment.scores.percentage >= 50).length,
    failedStudents: assessmentsMock.filter(a => a.assessment.scores.percentage < 50).length,
    passingScore: 50,
    title: 'Quarterly Assessment - All Subjects',
    description: 'Comprehensive assessment covering all subjects for the current academic quarter',
  },
  assessments: assessmentsMock,
  action: { created: mockUserAction },
};
